
import {ClassicType} from "../../shared/models/ClassicType";
import {Prodotto} from "../../Progetti/Models/Prodotto";

export class SerialKey extends  Prodotto{
  id: number;
  seriale: string;
  categoria: number;
  acquisto: number;
  rivenditore: string;
  numeroDoc: string;
  dataDoc: string;
  allegato: string;
  ricevuta: any;
  acquistoObject: ClassicType;
  file: string;
  matricola: string;
}
